import React, { Component } from 'react'
import { connect } from 'react-redux'
import DetailsRow from './DetailsRow'
import i18n from '../../../i18n'
import ReactTooltip from 'react-tooltip'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import s from './DetailsTable.css'
import './tooltip.css'
library.add(faInfoCircle)

class DetailsTable extends Component {
  renderReportingDate() {
    const { fundUnderlying } = this.props

    let date = new Date(fundUnderlying[0].cobDate)
    date = new Date(date.getTime() + date.getTimezoneOffset() * 60000)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }

  renderStdPerfReportingDate() {
    const { stdPerformance } = this.props

    let date = new Date(stdPerformance[0].dt)
    // date.setDate(date.getUTCDate())
    date = new Date(date.getTime() + date.getTimezoneOffset() * 60000)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' }
    return new Date(date).toLocaleDateString('en-us', options)
  }

  renderGTROptionRollDate() {
    const { fundUnderlying } = this.props

    let date = new Date(fundUnderlying[0].firstRestrikeDate)

    date.setDate(date.getUTCDate())
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }
  renderGTRInceptionDate() {
    const { fundUnderlying } = this.props

    let date = new Date(fundUnderlying[0].commonPeriodInceptionDate)

    date.setDate(date.getUTCDate())
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }

  renderStrategyRollDate() {
    const { fundUnderlying } = this.props

    let date = new Date(fundUnderlying[0].firstRestrikeDate)

    date.setDate(date.getUTCDate())
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date).toLocaleDateString([], options)
  }
  formatDate(string) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(string).toLocaleDateString([], options)
  }

  renderStrategyRows() {
    const { optionDetails } = this.props

    if (optionDetails) {
      return optionDetails.map(fund => {
        return <DetailsRow key={fund.djangoRow} data={fund} type={'optionDetails'} />
      })
    }
  }

  renderGTRNavRows() {
    const { fundUnderlying } = this.props

    if (fundUnderlying) {
      const competitors = fundUnderlying.filter(x => x.entityTier != 'competitor')
      return competitors.map(fund => {
        return <DetailsRow key={fund.ripRow} data={fund} type={'fund-underlying'} />
      })
    }
  }

  renderStdPerformanceRows() {
    const { stdPerformance } = this.props

    if (stdPerformance) {
      return stdPerformance.map(fund => {
        return <DetailsRow key={fund.dJangoRow} data={fund} type={'stdPerformance'} />
      })
    }
  }

  // create the header Index Holdings
  renderStrategyHeader() {
    return (
      <thead>
        <tr>
          <th colSpan='1' className={s.textLeft}>
            {'Weight'}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('ticker')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('current-ETF-price')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('etf-price-rollover')} <br /> {this.renderStrategyRollDate()}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('% Change')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('contract')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'contract'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'contract'} type='light' className='feetip' effect='float'>
              <strong>Contract</strong>
              <br />
              Denotes whether the options contract is purchased (long) or sold (short).
            </ReactTooltip>
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('strike-price')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'strikePrice'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'strikePrice'} type='light' className='feetip' effect='float'>
              <strong>Strike Price</strong>
              <br />
              Also known as the exercise price, this value represents the price in the underlying ETF at which an option can be exercised.
            </ReactTooltip>
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('original-option-price')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'origOptPrice'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'origOptPrice'} type='light' className='feetip' effect='float'>
              <strong>Original Option Price</strong>
              <br />
              The price at which the original options position was initiated.
            </ReactTooltip>
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('current-option-price')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'currOptPrice'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'currOptPrice'} type='light' className='feetip' effect='float'>
              <strong>Current Option Price</strong>
              <br />
              The current market price of the option.
            </ReactTooltip>
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('premium-paid-rollover')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'premium-paid-rollover'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'premium-paid-rollover'} type='light' className='feetip' effect='float'>
              <strong>Premium Paid At Rollover</strong>
              <br />
              The net amount (%) that was paid in order to gain exposure to all of the options in the portfolio at rollover. This value also represents the theoretical maximum loss for an investor that owned the strategy as of the rollover date.
            </ReactTooltip>
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('option-value-today')}
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'option-value-today'} icon='info-circle' size='xs' />
            <ReactTooltip arrowColor='transparent' id={'option-value-today'} type='light' className='feetip' effect='float'>
              <strong>Option Value Today</strong>
              <br />
              Intrinsic Value plus Extrinsic Value
            </ReactTooltip>
          </th>
          {/* <th colSpan='1' className={s.textCenter}>{i18n.t('intrinsic-value')}
          <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }}
              data-tip data-for={'intrinsic-value'} icon="info-circle" size="xs" />
            <ReactTooltip arrowColor="transparent" id={'intrinsic-value'} type='light' className="feetip" effect="float">
              <strong>Intrinsic Value</strong><br />
              TThe value of the options contract if it were exercised today. An option is said to have intrinsic value if the exercise price of a call option is below the current market price.
            </ReactTooltip></th>
          <th colSpan='1' className={s.textCenter}>{i18n.t('extrinsic-value')}
          <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '14px', color: '#ffffff', marginLeft: '2px', cursor: 'pointer' }}
              data-tip data-for={'extrinsic-value'} icon="info-circle" size="xs" />
            <ReactTooltip arrowColor="transparent" id={'extrinsic-value'} type='light' className="feetip" effect="float">
              <strong>Extrinsic Value</strong><br />
              Represents the premium paid for an option in excess of it’s intrinsic value.
            </ReactTooltip></th> */}
        </tr>
      </thead>
    )
  }
  renderGTRNavHeader() {
    return (
      <thead>
        <tr>
          <th colSpan='1' className={s.textLeft}>
            {'Name'}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('Ticker')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('1-week')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('MTD')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('1-month')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('3-month')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('YTD')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('since')} {i18n.t('GTR')} <br /> {i18n.t('option-roll')} <br /> {this.renderGTROptionRollDate()}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('since')} {i18n.t('GTR')} <br /> {i18n.t('inception')} <br /> {this.renderGTRInceptionDate()}
          </th>
        </tr>
      </thead>
    )
  }

  renderStdPerformanceHeader() {
    return (
      <thead>
        <tr>
          <th colSpan='1' className={s.textLeft}>
            {'Fund Name'}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('Ticker')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('Net Expense Ratio')}{' '}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('Fund Inception')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('1-Year')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('3-Year')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('5-Year')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('10-Year')}
          </th>
          <th colSpan='1' className={s.textCenter}>
            {i18n.t('Since Inception')}
          </th>
        </tr>
      </thead>
    )
  }

  render() {
    const { fundUnderlying } = this.props

    if (fundUnderlying) {
      return (
        <div>
          <div>
            <div className='main-heading' style={{ color: '#5b6770', fontSize: '34px', fontWeight: '300', marginTop: '30px', marginBottom: '30px' }}>
              {i18n.t('Performance & Strategy Statistics')} <span style={{ color: '#5b6770', fontSize: '22px' }}> </span>
            </div>
            <div className='main-heading' style={{ color: '#5b6770', fontSize: '34px', fontWeight: '300', marginTop: '30px', marginBottom: '30px' }}>
              {i18n.t('WisdomTree Target Range Fund (GTR)')} <span style={{ color: '#5b6770', fontSize: '22px' }}> </span>
            </div>
            <div> </div>
          </div>

          <div className='heading' style={{ color: '#5b6770', fontSize: '28px', fontWeight: '300', marginTop: '30px', marginBottom: '30px' }}>
            {i18n.t('fund-nav')} <span style={{ color: '#5b6770', fontSize: '22px' }}>As Of</span> {this.renderReportingDate()}
          </div>
          <div className='table-responsive'>
            <table className={'table ' + 'tableFC'}>
              {this.renderGTRNavHeader()}
              <tbody>{this.renderGTRNavRows()}</tbody>
            </table>
          </div>

          <div className='perfdisc' style={{ color: '#5b6770', fontSize: '14px', fontWeight: '600', marginTop: '30px', marginBottom: '30px' }}>
            {i18n.t('stdPerfDisc')}
          </div>
          <div className='table-responsive'>
            <table className={'table ' + 'tableFC'}>
              {this.renderStrategyHeader()}
              <tbody>{this.renderStrategyRows()}</tbody>
            </table>
          </div>

          <div className='heading' style={{ color: '#5b6770', fontSize: '28px', fontWeight: '300', marginTop: '30px', marginBottom: '30px' }}>
            {i18n.t('Standardized Performance')} <span style={{ color: '#5b6770', fontSize: '22px' }}>As Of</span> {this.renderStdPerfReportingDate()}
          </div>
          <div className='table-responsive'>
            <table className={'table ' + 'tableFC'}>
              {this.renderStdPerformanceHeader()}
              <tbody>{this.renderStdPerformanceRows()}</tbody>
            </table>
          </div>
        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    fundUnderlying: state.data.fundUnderlying,
    optionDetails: state.data.optionDetails,
    stdPerformance: state.data.stdPerformance
  }
}

export default connect(mapStateToProps, {})(DetailsTable)



// WEBPACK FOOTER //
// ./src/components/App/DetailsTable/DetailsTable.js